import { getSession, setSession } from '@/utils/storage'
import { DICT_SESSION_PREFIX } from '@/utils/constant'
import * as dictMap from '@/utils/dict'
import { getDicByCode, allCountries, leaderList } from '@/server/common'
import { getProductTypes, getProductTags, getSupplierList } from '@/server/product'
import { getPubDomains } from '@/server/sitemap'
import { getListEmail } from '@/server/after-sales.js'
import { getList as getCollects } from '@/server/collections'
import { getModules as getLogModules } from '@/server/log'
import { getShopList } from '@/server/shopList.js'
import { getAuthAllUser } from '@/server/system.js'
import { getTeamCamlist } from '@/server/marketing.js'
import store from '@/store'
export const fetchOptions = (type, cache = true) => {
  const map = {
    staff_id: {
      fetch () {
        return leaderList().then(res => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data || []).filter(Boolean).map(i => ({ label: i.userName, value: i.userId }))
          }
          return res
        })
      }
    },
    duty_id: {
      fetch () {
        return getDicByCode(4).then(res => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data || []).filter(Boolean).map(i => ({ label: window.eventBus.$t(`system::responsible::${i.name}`, i.name), value: i.id }))
          }
          return res
        })
      }
    },
    source_id: {
      fetch () {
        return getDicByCode(3).then(res => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data || []).filter(Boolean).map(i => ({ label: window.eventBus.$t(`system::aftermarket::source::${i.name}`, i.name), value: i.id }))
          }
          return res
        })
      }
    },
    refund_id: {
      fetch () {
        return getDicByCode(2).then(res => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data || []).filter(Boolean).map(i => ({ label: window.eventBus.$t(`system::refund::type::${i.name}`, i.name), value: i.id }))
          }
          return res
        })
      }
    },
    email_type: {
      fetch () {
        return getDicByCode(5).then(res => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data || []).filter(Boolean).map(i => ({ label: window.eventBus.$t(`system::email::category::${i.name}`, i.name), value: i.id }))
          }
          return res
        })
      }
    },
    shop_id: {
      fetch () {
        return getShopList({ pageSize: 10000, pageNum: 1 }).then(res => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data.items || []).filter(Boolean).map(i => ({ label: i.name, value: i.id }))
          }
          return res
        })
      }
    },
    product_type: {
      fetch () {
        return getProductTypes().then(res => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data || []).filter(Boolean).map(i => ({ label: i, value: i }))
          }
          return res
        })
      }
    },
    product_tag: {
      fetch () {
        return getProductTags().then(res => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data.tags || []).filter(Boolean).map(i => ({ label: i.name, value: i.name }))
          }
          return res
        })
      }
    },
    country: {
      fetch () {
        return allCountries().then(res => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data || []).filter(Boolean).map(i => ({ label: i.nameZh, value: i.countryCode }))
          }
          return res
        })
      }
    },
    collections: {
      fetch () {
        return getCollects({ pageNum: 1, pageSize: 10000 }).then(res => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data.items || [])
              .filter(Boolean)
              .map(i => ({ label: i.title, value: i.id, ...i }))
          }
          return res
        })
      }
    },
    get_pub_domains: {
      fetch () {
        return getPubDomains().then(res => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data || []).map(i => ({ label: i, value: i }))
          }
          return res
        })
      }
    },
    module: {
      fetch () {
        return getLogModules().then((res) => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data || []).filter(Boolean).map((i) => ({ label: i.module, value: i.id }))
          }
          return res
        })
      }
    },
    supplier_id: {
      fetch () {
        return getSupplierList({ pageNum: 1, pageSize: 10000 }).then((res) => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data.items || []).filter(Boolean).map((i) => ({ label: i.name, value: i.id }))
          }
          return res
        })
      }
    },
    auth_user: {
      fetch () {
        return getAuthAllUser({userId: store.state.user.merchantId}).then((res) => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data || []).filter(Boolean).map((i) => ({ label: i.userName, value: i.userId }))
          }
          return res
        })
      }
    },
    team_cam: {
      fetch () {
        return getTeamCamlist().then((res) => {
          if (res.data.code === 0) {
            res.data.data = (res.data.data || []).filter(Boolean).map((i) => ({ label: i.loginName, value: i.userId }))
          }
          return res
        })
      }
    },
  }
  const dictList = dictMap[type]
  if (dictList) return Promise.resolve(dictList)
  const typeObj = map[type] || {}
  let { fetch, formatItem } = typeObj
  if (!fetch) {
    fetch = function () {
      return getDicByCode(type)
    }
    formatItem = function (item) {
      return {
        label: item.dictItemKey,
        value: item.dictItemValue,
        ...item
      }
    }
  }
  const sessionKey = DICT_SESSION_PREFIX + type
  let sessionList = getSession(sessionKey)
  if (sessionList === 'stopFetch') {
    sessionList = undefined
  }
  if (!cache || !sessionList) {
    setSession(sessionKey, 'fetching')
    return fetch().then(res => {
      if (res.data.code === 0) {
        let list = res.data.data || []
        if (typeof formatItem === 'function') {
          list = list.map(formatItem)
        }
        setSession(sessionKey, list)
        return list
      } else {
        setSession(sessionKey, 'stopFetch')
        // console.error(e)
      }
    })
  }
  if (sessionList === 'fetching') {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(fetchOptions(type, cache))
      }, 200)
    })
  }
  return Promise.resolve(sessionList || [])
}
